import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export interface MonthlyFailure {
  month: string;
  monthShort: string;
  failedPayments: number;
  totalAmount: number;
}

export interface DashboardFailedPaymentsOverviewResponse {
  attentionRequiredCount: number;
  totalFailedCountThisMonth: number;
  totalFailedAmountThisMonth: number;
  monthlyFailures: Array<MonthlyFailure>;
}

export const dashboardFailedPaymentsOverviewAPI = async () => {
  const response = await baseAPI.get<DashboardFailedPaymentsOverviewResponse>(
    '/dashboard/failed-payments-overview',
  );
  return response.data;
};

export const useDashboardFailedPaymentsOverview = () => {
  return useQuery({
    queryKey: ['dashboard-failed-payments-overview'],
    queryFn: dashboardFailedPaymentsOverviewAPI,
  });
};
